export default "__VITE_ASSET__BtFsQAZi__"